import _ from 'lodash'
import services from './services'
import utilities from './utilities'

const getters = {}

_.forIn(services, service => {
  getters[`${service.name}/instance`] = () => (
    _.cloneDeep(service.instanceDefaults)
  )
  // Alias of instance.
  getters[`${service.name}/schema`] = getters[`${service.name}/instance`]
})

utilities.mergeGetterExtensions(getters)

export default getters
